<template>
  <modal
    title="Modifier une ronde"
    @close="cancel()">

    <div class="ronde-update">
      <div v-if="updateModal.message !== null"
           v-bind:class="'callout callout-'+updateModal.message.type">
        <p>{{updateModal.message.text}}</p>
      </div>
      <div class="form-horizontal">
        <div class="form-group">
          <label class="control-label col-sm-4">Nom</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" v-model="ronde.nom"/>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Ronde BOM</label>
          <div class="col-sm-8">
            <input type="text" class="form-control" v-model="ronde.numero"/>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Agent référent</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="ronde.loginRef">
              <option></option>
              <option v-for="a in sortedAgents" :value="a.login">{{a.login}} - {{a.prenom}} {{a.nom}}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="control-label col-sm-4">Agent planifié</label>
          <div class="col-sm-8">
            <select class="form-control" v-model="ronde.loginPla">
              <option></option>
              <option v-for="a in sortedAgents" :value="a.login">{{a.login}} - {{a.prenom}} {{a.nom}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="buttons" v-if="!updateModal.canOnlyExitModal">
        <div class="btn btn-default" v-on:click="cancel()">Annuler</div>
        <div class="btn btn-primary" v-on:click="doUpdate()">Valider</div>
      </div>
      <div class="loading-overlay" v-if="updateModal.loading">
        Chargement ...
      </div>
    </div>

  </modal>
</template>

<script>
  import Modal from '../../modals/ModalBasic'

  export default {
    props: [
      'ronde',
    ],
    components: {
      Modal,
    },
    computed: {
      sortedAgents: function () {
        return this.$store.getters.sortedAgents
      },
      updateModal: function () {
        return this.$store.state.rondes.updateModal
      },
    },
    methods: {
      cancel: function () {
        this.$store.dispatch('closeRondeUpdateModal')
      },
      doUpdate: function () {
        console.log("ronde to update => " , this.ronde)
        this.$store.dispatch('updateRondeV2', {
          ronde: this.ronde,
        })
      },
    },
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// RondeUpdateModal.vue?4d75b14b